/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Pricing_Faq_6_QInputs */

const en_mk_pricing_faq_6_q = /** @type {(inputs: Mk_Pricing_Faq_6_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What happens if I move down a plan?`)
};

const id_mk_pricing_faq_6_q = /** @type {(inputs: Mk_Pricing_Faq_6_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang terjadi kalau saya turun paket?`)
};

/**
* | output |
* | --- |
* | "What happens if I move down a plan?" |
*
* @param {Mk_Pricing_Faq_6_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_pricing_faq_6_q = /** @type {((inputs?: Mk_Pricing_Faq_6_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Pricing_Faq_6_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_pricing_faq_6_q(inputs)
	return en_mk_pricing_faq_6_q(inputs)
});